import React from "react";
import { BookOpen, Heart, Star, TrendingUp, Users, ZoomIn } from "lucide-react";

const T = (f) => `/landing/tutors/${f}`;
const DEDIKASI = { ms: "Dedikasi Membina Generasi Cemerlang", en: "Dedicated To Building An Excellent Generation" };

/* Tambah tutor baharu di sini sahaja (foto: /public/landing/tutors/{slug}.webp, poster: poster-{slug}.jpg) */
export const ONLINE_TUTORS = [
  { slug: "yaya", name: "Cikgu Yaya", creds: [{ ms: "Ijazah Sarjana Muda Teknologi Serta Pendidikan", en: "Bachelor's Degree in Technology & Education" }, { ms: "UTM / Guru Sekolah SMKTNJ", en: "UTM / School Teacher, SMKTNJ" }, DEDIKASI] },
  { slug: "husna", name: "Cikgu Husna", creds: [{ ms: "Pendidikan Ijazah Sarjana Muda", en: "Bachelor's Degree" }, { ms: "Pentadbiran Perniagaan Kewangan", en: "Business Administration (Finance)" }, DEDIKASI] },
  { slug: "nasha", name: "Cikgu Nasha", creds: [{ ms: "Pendidikan Guru Personel MySTEP", en: "MySTEP Personnel Teacher" }, { ms: "Guru KGSK", en: "KGSK Teacher" }, DEDIKASI] },
  { slug: "nazira", name: "Cikgu Nazira", creds: [{ ms: "Guru Personel MySTEP", en: "MySTEP Personnel Teacher" }, { ms: "Bidang Pendidikan Open University", en: "Education, Open University" }, DEDIKASI] },
  { slug: "miza", name: "Cikgu Miza", creds: [{ ms: "Pendidikan Ijazah Sarjana Muda (Kepujian)", en: "Bachelor's Degree (Honours)" }, { ms: "Eksekutif Developer Company", en: "Executive, Developer Company" }, DEDIKASI] },
  { slug: "afifah", name: "Cikgu Afifah", creds: [{ ms: "Ijazah Sarjana Muda", en: "Bachelor's Degree" }, { ms: "Pengurusan Teknologi Dengan Kepujian", en: "Technology Management (Honours)" }, { ms: "Warehouse Executive", en: "Warehouse Executive" }] },
];

const CRED_ICONS = [BookOpen, Users, TrendingUp];

function TutorCard({ tutor, ms, index, onOpen }) {
  return (
    <button
      type="button"
      onClick={() => onOpen(T(`poster-${tutor.slug}.jpg`))}
      className={`pmm-pop group relative flex h-full w-full flex-col overflow-hidden rounded-2xl border-2 border-yellow-400/70 bg-gradient-to-b from-navy-950 via-navy-900 to-navy-800 text-left shadow-xl shadow-navy-950/30 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-yellow-500/25`}
      style={{ animationDelay: `${0.08 * index}s` }}
      data-testid={`online-tutor-card-${tutor.slug}`}
    >
      <div className="absolute inset-x-0 top-0 z-10 h-1 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" />

      {/* Foto + latar */}
      <div className="relative aspect-[4/5] w-full overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_60%_35%,rgba(255,255,255,0.95),rgba(214,222,240,0.75)_45%,rgba(16,29,60,0)_75%)]" />
        {/* swoosh emas & oren */}
        <div className="absolute -left-10 bottom-10 h-10 w-[140%] -rotate-12 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600 opacity-90" />
        <div className="absolute -left-10 bottom-4 h-6 w-[140%] -rotate-12 bg-gradient-to-r from-orange-800 to-orange-500" />
        {/* Eyebrow TUTOR PMM */}
        <div className="absolute left-2.5 top-3 z-10 leading-[0.85] sm:left-3">
          <div className="font-display text-[13px] font-extrabold uppercase italic text-transparent drop-shadow sm:text-2xl" style={{ backgroundImage: "linear-gradient(180deg,#f5e08d,#f0a500 60%,#d08400)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>Tutor</div>
          <div className="font-display text-[13px] font-extrabold uppercase text-transparent drop-shadow sm:text-2xl" style={{ backgroundImage: "linear-gradient(180deg,#ffffff,#c9d1e3)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>PMM</div>
        </div>
        <img
          src={T(`${tutor.slug}.webp`)}
          alt={tutor.name}
          loading="lazy"
          className="absolute bottom-0 left-1/2 z-[5] h-[84%] w-auto max-w-none -translate-x-[40%] sm:h-[92%] sm:-translate-x-[42%] object-contain object-bottom drop-shadow-2xl transition-transform duration-700 group-hover:scale-105"
          style={{ WebkitMaskImage: "linear-gradient(to bottom, #000 88%, transparent)", maskImage: "linear-gradient(to bottom, #000 88%, transparent)" }}
        />
        <span className="absolute right-2 top-2 z-10 grid h-7 w-7 place-items-center rounded-full bg-navy-950/70 text-yellow-300 opacity-0 ring-1 ring-yellow-400/60 transition-opacity duration-300 group-hover:opacity-100">
          <ZoomIn className="h-3.5 w-3.5" />
        </span>
      </div>

      {/* Nama */}
      <div className="relative z-10 -mt-4 px-2">
        <div className="mx-auto w-fit rounded-full border border-yellow-200 bg-gradient-to-b from-yellow-200 via-yellow-400 to-yellow-600 whitespace-nowrap px-2.5 py-1 text-center font-display text-[10.5px] font-extrabold uppercase tracking-wide text-navy-950 shadow-lg shadow-yellow-700/30 sm:px-5 sm:text-base" data-testid={`online-tutor-name-${tutor.slug}`}>
          {tutor.name}
        </div>
      </div>

      {/* Kelayakan */}
      <ul className="flex-1 space-y-1.5 px-2.5 pb-3 pt-3 sm:space-y-2 sm:px-3.5">
        {tutor.creds.map((c, i) => {
          const Icon = CRED_ICONS[i % CRED_ICONS.length];
          return (
            <li key={i} className="flex items-center gap-2">
              <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full border border-yellow-400 bg-navy-950 text-yellow-300 sm:h-8 sm:w-8">
                <Icon className="h-3 w-3 sm:h-4 sm:w-4" />
              </span>
              <span className="text-[9px] font-bold uppercase leading-tight text-white/90 sm:text-[11px]">{ms ? c.ms : c.en}</span>
            </li>
          );
        })}
      </ul>
    </button>
  );
}

export default function TutorOnlineBlock({ ms, setLightbox }) {
  const L = (m, e) => (ms ? m : e);
  return (
    <div className="overflow-hidden rounded-2xl border-2 border-navy-100 bg-white shadow-lg" data-testid="online-tutor-block">
      {/* Kepala */}
      <div className="relative overflow-hidden bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800 px-4 pb-5 pt-5 text-center">
        <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" />
        <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-yellow-400/20 blur-2xl" />
        <div className="relative flex items-center justify-center gap-1.5 text-[10px] font-extrabold uppercase tracking-[0.25em] text-yellow-300">
          <Star className="h-3 w-3 fill-yellow-400 text-yellow-400" /> {L("Kenali Tutor Kami", "Meet Our Tutors")} <Star className="h-3 w-3 fill-yellow-400 text-yellow-400" />
        </div>
        <h4 className="relative mt-1 font-display text-2xl font-extrabold uppercase leading-none text-white sm:text-3xl">
          Tutor <span className="text-transparent" style={{ backgroundImage: "linear-gradient(180deg,#f5e08d,#f0a500)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>{L("Kelas Online", "Online Class")}</span> PMM
        </h4>
        <p className="relative mt-1.5 font-script text-xl text-yellow-200 sm:text-2xl">{L("Pendidikan Bermula Dengan Membaca", "Education Begins With Reading")}</p>
      </div>

      {/* Grid tutor */}
      <div className="grid grid-cols-2 gap-3 bg-gradient-to-b from-navy-50 to-white p-3 sm:gap-4 sm:p-4" data-testid="online-tutor-grid">
        {ONLINE_TUTORS.map((t, i) => (
          <div key={t.slug} className={ONLINE_TUTORS.length % 2 === 1 && i === ONLINE_TUTORS.length - 1 ? "col-span-2 mx-auto w-1/2" : "h-full"}>
            <TutorCard tutor={t} ms={ms} index={i} onOpen={setLightbox} />
          </div>
        ))}
      </div>

      {/* Skrip + lencana */}
      <div className="flex items-center justify-between gap-3 px-4 pb-4">
        <p className="font-script text-xl font-bold leading-tight text-navy-900 sm:text-2xl">
          {L("\u201CAnak Mesti Lancar Membaca\u201D", "\u201CEvery Child Must Read Fluently\u201D")}
        </p>
        <div className="grid h-20 w-20 shrink-0 place-items-center rounded-full bg-gradient-to-br from-yellow-200 via-yellow-500 to-yellow-700 p-1 shadow-lg" data-testid="online-tutor-badge">
          <div className="grid h-full w-full place-items-center rounded-full bg-navy-950 text-center">
            <div className="leading-none">
              <div className="text-[7px] font-extrabold uppercase text-white">{L("Bersama", "Together")}</div>
              <div className="font-display text-base font-extrabold text-yellow-300">PMM</div>
              <div className="px-1 text-[6px] font-bold uppercase leading-tight text-white/85">{L("Melahirkan Generasi Cemerlang", "Raising An Excellent Generation")}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Jalur bawah */}
      <div className="grid grid-cols-3 divide-x divide-yellow-400/30 bg-gradient-to-r from-navy-950 via-navy-900 to-navy-950 py-2.5 text-white">
        {[
          { icon: BookOpen, t: L("Ilmu", "Knowledge") },
          { icon: Heart, t: L("Dedikasi", "Dedication") },
          { icon: Users, t: L("Generasi Cemerlang", "Excellent Generation") },
        ].map((x) => (
          <span key={x.t} className="flex items-center justify-center gap-1.5 px-1 text-[10px] font-bold sm:text-xs">
            <x.icon className="h-4 w-4 shrink-0 fill-yellow-400/80 text-yellow-400" /> {x.t}
          </span>
        ))}
      </div>
    </div>
  );
}
